package com.partejar.app.feature.workspace.data

import kotlinx.serialization.Serializable

@Serializable
data class SessionBootstrapDto(
    val usuario: SessionUser,
    val workspaces: List<UserWorkspace>
)

@Serializable
data class SessionUser(
    val id: Long,
    val nome: String,
    val email: String
)

@Serializable
data class UserWorkspace(
    val id: Long,
    val nome: String,
    val perfil: WorkspaceProfile,
    val categoriaProfissional: String,
    val vinculoAtivo: Boolean = true,
    val usuarioAtualEhProprietario: Boolean = false
) {
    val canEdit: Boolean get() = usuarioAtualEhProprietario
}

@Serializable
data class WorkspaceProfile(
    val codigo: String,
    val nome: String
)

@Serializable
data class WorkspaceNameRequest(val nome: String)
